// Vue
import { Vue, Component } from "vue-property-decorator";
// Mobx
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
// ViewModel
import { uuid } from "#/common/Utils";
import { ContentModule } from "../../common/content_module/ContentModule";
import { Headline } from "../../../components/headline/Headline";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ContentModule,
    Headline,
  },
})
export class ModellbeschreibungPflegeModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return instance["content"]["section_color"]["color"];
  }

  get contentData() {
    return this.instance["content"];
  }

  get fklnr() {
    return this.instance["fklnr"].map((e) => e["fklnr"]);
  }

  get fklnrString() {
    return this.fklnr.join(", ");
  }
}
